<template>
    <div data-cy="container_mission_transaction_detail_condition">
        <div class="relative z-10 px-4">
            <div class="bg-a-white-ffffff w-full px-5 pb-5 pt-1 rounded-lg" data-cy="container_mission_transaction_detail_tabs">
                <div class="flex bg-a-blue-f2f5ff rounded-full mt-5">
                    <div class="py-2 px-4 cursor-pointer w-full text-center rounded-full"
                        data-cy="btn_mission_transaction_tab_detail"
                        :class="[active == 'detail' ? 'text-white bg-a-blue-2140a6' : 'text-a-gray-a4a4a4']"
                        @click="clickTab('detail')">
                        {{lbl.mission.transaction_detail}}
                    </div>
                    <div class="py-2 px-4 cursor-pointer w-full text-center rounded-full"
                        data-cy="btn_mission_transaction_tab_condition"
                        :class="[active == 'condition' ? 'text-white bg-a-blue-2140a6' : 'text-a-gray-a4a4a4']"
                        @click="clickTab('condition')">
                        {{lbl.mission.transaction_condition}}
                    </div>
                </div>
                <div class="h-52 mt-3">
                    <div class="transaction-detail h-full overflow-auto text-14 text-a-gray-666666 leading-normal">
                        <div v-show="active == 'detail'" v-html="detailText"></div>
                        <div v-show="active == 'condition'" v-html="conditionText"></div>
                    </div>
                </div>
            </div>
            <div class="w-full text-center mt-5 pb-4" v-if="isShowBtn" 
                 :style="{ 
                    '--btn-play-url': 'url(' + getBtnPlayUrl() + ')',
                    '--btn-play-disabled-url': 'url(' + getBtnPlayDisabledUrl() + ')'
                 }">
                <button class="btn-play disabled font-bold text-18 text-center text-a-gray-a4a4a4 mx-auto"
                    data-cy="btn_mission_transaction_confirm_disabled"
                    v-if="isBtnDisable">
                    {{ lbl.mission.btn_transaction_confirm }}
                </button>
                <button class="btn-play font-bold text-18 text-center text-a-blue-f2f5ff mx-auto"
                    data-cy="btn_mission_transaction_confirm"
                    @click="onClickConfirm()" v-else>
                    {{ lbl.mission.btn_transaction_confirm }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin';
//helper
import Util from "@/helper/Utility.js";
import ConfigManager from '@/config/ConfigManager.js';
import DatetimeHelper from '@/helper/DatetimeHelper';
//service
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
import BzbsRedeem from '@/core/Redeem/service/BzbsRedeem.js';
import MissionService from '../service/MissionService.js';

export default {
    name: 'DetailAndConditionGame',
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    props: {
        mission:    { type: Object, required: true },
    },
    data: function(){
        return {
            missionId: '',
            campaignId: '',
            redeemId: '',
            active: 'detail',
            detailText: null,
            conditionText: null,

            isShowBtn: true,
            isBtnDisable: false,
            isBtnSpecial: false,
        }
    },
    created: async function() {
        this.missionId = this.mission.Id;
        this.campaignId = this.mission.CampaignId;
    },
    mounted: async function(){
        this.tracking.screenName('mission');
        this.checkBtnDisable();
        this.getRedeemId();

        this.modal.loadingModal.show();
        await this.getDetail();
        this.modal.loadingModal.hide();
    },
    methods: {
        getRedeemId: function(){
            if(this.mission && this.mission.SubMissions){
                //let today = new Date('September 6, 2023 18:59:59'); //for test
                let today = new Date();
                let submission = this.mission.SubMissions.filter((item) =>{
                    // let start = new Date(item.StartDate * 1000);
                    // let end = new Date(item.EndDate * 1000);
                    let start = DatetimeHelper.unixTimestampToDate(item.StartDate);
                    let end = DatetimeHelper.unixTimestampToDate(item.EndDate);
                    return (today >= start  && today <= end )
                })[0];
                if(submission){
                    this.redeemId = submission.CampaignId ? submission.CampaignId : this.mission.CampaignId;

                    if(submission.Confirmed == true){
                        this.isBtnDisable = true;
                    }

                }else{
                    this.redeemId = this.mission.CampaignId;
                    this.isBtnDisable = true;
                }
            }else{
                this.redeemId = this.mission.CampaignId;
            }
        },
        checkBtnDisable: function(){
            this.isShowBtn = this.mission.MissionConfirm;
            if (this.mission && this.mission.SubMissions) {
                let confirmed = this.mission.SubMissions.filter((item) => item.Confirmed == true)
                let qty = this.mission.SubMissions.filter((item) => item.CampaignQty <= 0);
                if(this.mission.UI == null){
                    if (confirmed.length > 0) {
                        this.isBtnDisable = true;
                    }
                } else {
                    if ((confirmed.length <= 0 && qty.length > 0)
                        || qty.length > 0 || confirmed.length > 0) {
                        this.isBtnDisable = true;
                    } else {
                        this.isBtnDisable = false;
                    }
                }
            } else {
                this.isBtnDisable = this.mission.Confirmed;
            }
        },
        getDetail: function(){
            if(!this.campaignId) return;

            let campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaignId)
                .create();

            return new Promise((resolve) => {
                BzbsCampaign.apiGetCampaignDetail(campaignConfig).subscribe((campaign) => {
                    this.detailText = Util.newLineToBr(campaign.detail);
                    this.conditionText = Util.newLineToBr(campaign.condition);

                    resolve(true);
                }, (err) => {
                    this.errorApi(err);
                    console.log(err);
                    resolve(null);
                });
            });
        },
        clickTab: function(active) {
            this.active = active;
        },
        onClickConfirm: async function(){
            let campaign = await this.apiRedeem();

            this.modal.loadingModal.show();
            await this.apiMissionConfirm(campaign.ItemNumber);
            this.modal.loadingModal.hide();
            window.location.reload();
        },
        apiRedeem: function(){
            return new Promise((resolve) =>{
                BzbsRedeem.apiRedeemCampaign(this.redeemId, null, 1).subscribe({
                    next: (campaign) => {
                        resolve(campaign)
                    },
                    error: (err) => {
                        this.errorApi(err);
                        console.log(err);
                        resolve(null)
                    },
                })
            })
        },
        apiMissionConfirm: function(itemNumber){
            return new Promise((resolve) =>{
                let params = {
                    id: this.missionId,
                    campaign: this.redeemId,
                    itemNumber: itemNumber,
                }
                MissionService.missionConfirm(params).subscribe({
                    next: (res) => {
                        resolve(res)
                    },
                    error: (err) => {
                        this.errorApi(err);
                        console.log(err);
                        resolve(null)
                    },
                })
            })
        },
        getBtnPlayUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-btn.png`;
        },
        getBtnPlayDisabledUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-btn-disable.png`;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.btn-play{
    min-width: 192px;
    height: 67px;
    background-image: var(--btn-play-url);
    background-position: top center;
    background-repeat: no-repeat;

    &.disabled{
        background-image: var(--btn-play-disabled-url);
    }
}

.coming-soon{
    min-height: calc(100vh - 120px);
}
</style>
<style lang="scss">
.transaction-detail{
    ul{
        list-style: disc;
        padding: 5px 0{
            left: 20px;
        }

        li{
            padding: 5px 0;
        }
    }
    ol{
        list-style: auto;
        padding-left: 35px;

        li{
            padding: 5px 0;
        }
    }
    p{
        padding-left: 30px;
    }
}
</style>
